import React from "react";
import "./ProblemStatus.scss";
import {
  getTicketStatusMeta,
} from "../../../../../Problematikat/SupportInbox/utils/ticketStatus";

function ProblemStatus({ status }) {
  const meta = getTicketStatusMeta(status);
  return (
    <div
      className="problemStatus"
      style={{
        backgroundColor: meta.backgroundColor,
        color: meta.color,
        cursor: "pointer",
      }}
    >
      {meta.label}
    </div>
  );
}

export default ProblemStatus;
